import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { ReviewsSnippetRating } from '../ReviewsSnippetRating';

interface IProps {
  className?: string;
  rating?: string | null;
  reviewsCount?: string | null;
  showInfoIcon: boolean;
  onInfoClick?: VoidFunction;
}

export function ReviewsSnippetHeader({ className, rating, reviewsCount, showInfoIcon, onInfoClick }: IProps) {
  return (
    <div className={cx(styles['header'], className)}>
      <ReviewsSnippetRating reviewsClassName={styles['reviews']} rating={rating} reviewsCount={reviewsCount} />

      {showInfoIcon && <IconFunctionalInformationCircle16 onClick={onInfoClick} />}
    </div>
  );
}
